import { last } from "lodash";
import { useParameter, useDictionaryItem, yearToCropYearShort } from "../../../shared";
import { dictionaryService } from "../../../dataFlow";

export function useSlideSubtitle() {
  const [parameterValues] = useParameter<number[]>("@calendar");
  const [, calendarName] = useDictionaryItem(dictionaryService, "slides-calendar", last(parameterValues));

  const [commodities] = useParameter<string[]>("@commodities_display");
  const [business] = useParameter<number>("@business-units");
  const [commodityItem] = useDictionaryItem(dictionaryService, "slides-commodities-display", Number(last(commodities)), {
    business_unit: Number(business),
    slide: 1,
  });

  const year = calendarName ? Number(calendarName) : new Date().getFullYear() - 1;
  const usdaSubtitle = `USDA marketing year (eg. ${yearToCropYearShort(year)} = Crop Year ${yearToCropYearShort(year - 1)})`;
  const comment = commodityItem?.getValue<string | null>("comment");
  const subtitle = !comment && comment !== "" ? usdaSubtitle : comment;
  return subtitle;
}
